export default __webpack_public_path__ + "static/media/featured-ads.22b4b294.jpg";